import { IActivity, IExamAnswer } from '@dtos/Activity'
import { create } from 'zustand'

interface IActivityStore {
  activity: IActivity | null
  examAnswer: IExamAnswer | null
  isRetrying: boolean
  setActivity: (activity: IActivity) => void
  startRetry: () => void
  finishRetry: () => void
  finishRetryByNavigation: () => void
}

export const useActivityStore = create<IActivityStore>((set, get) => ({
  activity: null,
  examAnswer: null,
  isRetrying: false,
  setActivity: (activity) => set({ activity }),
  startRetry: () => {
    const { activity } = get()
    if (activity) {
      // Limpa as respostas da atividade
      const clearedActivity = {
        ...activity,
        examAnswer: undefined,
      }
      set({
        activity: clearedActivity,
        isRetrying: true,
        examAnswer: activity.examAnswer,
      })
    }
  },
  finishRetry: () => set({ isRetrying: false }),
  finishRetryByNavigation: () => {
    const { examAnswer, activity } = get()
    if (activity) {
      const newActivity = {
        ...activity,
        examAnswer: examAnswer || undefined,
      }
      set({
        activity: newActivity,
        isRetrying: false,
        examAnswer: null,
      })
    }
  },
}))
